import { List } from 'immutable';
import Suggestions from './model';
import SkillSuggestion from './SkillSuggestion';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillSuggestions':
      return [key, new List(val.map((skillSuggestion) => SkillSuggestion.create(skillSuggestion)))];
    default:
      return [key, val];
  }
};

const create = (data) => new Suggestions(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/create.js